'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.UUIDGenerator = void 0;
var tslib_1 = require('tslib');
var Dependency_1 = require('./Dependency');
var UUIDGenerator = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UUIDGenerator, _super);
    function UUIDGenerator() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.id = 0;
        return _this;
    }
    UUIDGenerator.prototype.toString = function () {
        return 'UUIDGenerator';
    };
    UUIDGenerator.prototype.uuid = function (prefix) {
        return ''.concat(prefix ? ''.concat(prefix, '_') : '').concat(this.id++);
    };
    return UUIDGenerator;
})(Dependency_1.Dependency);
exports.UUIDGenerator = UUIDGenerator;
